export const faqs = [
    {
        question: "Can I settle my True Credits (TrueBalance) loan?",
        answer: "Yes, if you are unable to repay your loan from True Credits Pvt Ltd (the NBFC behind TrueBalance app) due to financial difficulties, you can opt for a One Time Settlement (OTS). This allows you to close the loan by paying a reduced amount."
    },
    {
        question: "True Credits agents are calling my contacts. Is this legal?",
        answer: "No, accessing your contact list and calling your friends or family to shame you is a violation of RBI's Digital Lending Guidelines. It constitutes harassment. We can take legal action to stop this immediately."
    },
    {
        question: "What happens if I don't pay my TrueBalance loan?",
        answer: "If you default, your credit score (CIBIL) will be severely damaged. You will face penalty charges and aggressive recovery calls. In some cases, they may initiate arbitration proceedings or send legal notices."
    },
    {
        question: "How much discount can I get in settlement?",
        answer: "For unsecured digital loans like True Credits, settlements can often be negotiated at 40-60% of the outstanding principal plus interest. The exact amount depends on your delinquency duration and financial hardship proof."
    },
    {
        question: "Will the default be removed from CIBIL after settlement?",
        answer: "No, the account status will change to 'Settled'. This is better than 'Written Off' but still impacts your score. However, it stops further damage, and you can start rebuilding your score after 6-12 months."
    },
    {
        question: "Do I need to pay the penalty charges?",
        answer: "In a settlement, we typically negotiate for a complete waiver of all penalty charges and late fees. You usually only pay a portion of the principal and normal interest."
    },
    {
        question: "Can they file a police case against me?",
        answer: "Non-payment of a personal loan is a civil matter, not a criminal one. Police cannot arrest you for this. However, if you have issued a cheque that bounced, a case under Section 138 can be filed, which we can help you fight."
    },
    {
        question: "Is it safe to pay through the app for settlement?",
        answer: "For settlement, it is safer to get a formal settlement letter first. Once you have the letter, you can pay directly to the True Credits bank account mentioned in the letter. Avoid paying cash to agents."
    },
    {
        question: "How long does the process take?",
        answer: "The settlement negotiation usually takes 2-3 weeks. We handle the communication with their legal/recovery team to get you the best deal."
    },
    {
        question: "What documents do I need?",
        answer: "You need your loan account details (from the app), PAN card, Aadhaar card, and any proof of financial distress (like job loss letter or medical records)."
    },
    {
        question: "Why should I hire a lawyer for a small loan?",
        answer: "Even for small loans, the harassment can be mentally torturous. A lawyer puts a legal shield between you and the recovery agents, ensuring your peace of mind and preventing illegal recovery tactics."
    },
    {
        question: "What is True Credits Pvt Ltd?",
        answer: "True Credits Pvt Ltd is the RBI-registered Non-Banking Financial Company (NBFC) that lends money through the TrueBalance app. Your loan agreement is with them."
    },
    {
        question: "Can I get a loan in the future?",
        answer: "It will be difficult to get unsecured loans immediately. You should focus on rebuilding your credit score using secured credit cards (FD backed) for a year or two."
    },
    {
        question: "Do they use arbitration?",
        answer: "Yes, many digital lenders including True Credits have arbitration clauses. They may appoint an arbitrator to pass an award against you. We can represent you in these proceedings."
    },
    {
        question: "I received a legal notice on WhatsApp. Is it valid?",
        answer: "Legal notices can be sent via WhatsApp, but many sent by recovery agents are fake drafts designed to scare you. We can verify the authenticity of the notice and reply to it legally."
    }
];
